import React, { useState } from "react"
import { Button } from "components/button"
import { DropdownChevron } from "assets/helper/icons"
import { Link } from "gatsby"
import { useLayout } from "contexts/components/LayoutContext"
import { useKeydownEscKey } from "hooks/keyboardEvents/useKeydownEscKey"
import { ChildPagesFormatted } from "contexts/settings/Navigation/navigation-types"

interface ServiceDropdownProps {
  serviceAreas: ChildPagesFormatted[]
}

export const ServiceDropdown = ({ serviceAreas }: ServiceDropdownProps) => {
  const { slug, linkedPagesUrlPathCodex } = useLayout()

  const [activeServiceArea, setActiveServiceArea] = useState(() => {
    const DEFAULT_TEXT_HOMEPAGE = "Select Area"

    if (slug === "/") return DEFAULT_TEXT_HOMEPAGE

    const activeServiceArea = serviceAreas.find(
      serviceArea => serviceArea.slug !== "/" && serviceArea.slug.includes(slug)
    )

    if (!activeServiceArea) return DEFAULT_TEXT_HOMEPAGE

    return activeServiceArea.linkText
  })

  const inactiveServiceAreas = serviceAreas.filter(
    serviceArea => serviceArea.linkText !== activeServiceArea
  )

  const [isExpanded, setIsExpanded] = useState(false)
  const [isDropdownHovered, setIsDropdownHovered] = useState(false)

  const handleToggleDropdown = () => {
    setIsExpanded(isExpanded => !isExpanded)
  }

  const handleCloseDropdown = () => {
    setIsExpanded(false)
    setIsDropdownHovered(false)
  }

  const handleSelectedOption = (linkText: string) => {
    setActiveServiceArea(linkText)
    handleCloseDropdown()
  }

  const { onKeydown } = useKeydownEscKey({
    isOpen: isExpanded,
    onClose: handleCloseDropdown,
  })

  return (
    <div className="fr-secondary-header__navigation-element ">
      <div className="fr-secondary-header__navigation-element__label">
        Services in
      </div>

      <div
        className={`fr-secondary-header__navigation-element__dropdown ${
          isExpanded ? "active" : ""
        }`}
      >
        <Button
          variant="ghost-page-link"
          extraClassNames={`fr-secondary-header__navigation-element__dropdown ${
            isExpanded ? "active" : ""
          }`}
          onClick={handleToggleDropdown}
          onKeyDown={(event: React.KeyboardEvent) => onKeydown(event)}
        >
          <div className="fr-secondary-header__navigation-element__dropdown-label">
            {activeServiceArea}
            <span>
              <DropdownChevron />
            </span>
          </div>
        </Button>
        <ul
          className={`fr-secondary-header__navigation-element__dropdown-options`}
          onMouseEnter={() => {
            !isDropdownHovered && setIsDropdownHovered(true)
          }}
          onMouseLeave={() => {
            isDropdownHovered && handleCloseDropdown()
          }}
        >
          {inactiveServiceAreas.map(({ linkText, slug }, i) => {
            const path = linkedPagesUrlPathCodex[slug] || "404"
            const formattedSlug = path.startsWith("/") ? path : `/${path}`

            return (
              <Link
                key={`${linkText}-${i}`}
                to={formattedSlug}
                onClick={() => handleSelectedOption(linkText)}
              >
                <li className="fr-secondary-header__navigation-element__dropdown-item">
                  {linkText}
                </li>
              </Link>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
